<script setup>
import { useI18n } from 'vue-i18n';
import GlossySwipe from './effects/GlossySwipe.vue';

const { t } = useI18n();

defineProps({
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['small', 'default', 'large'].includes(value)
  }
});
</script>

<template>
  <GlossySwipe>
    <img
      src="/icons/senyumlogo.png"
      :class="{
        'w-20 h-12': size === 'small',
        'w-48 h-24': size === 'default',
        'w-105 h-56': size === 'large'
      }"
      :alt="t('logo.title')"
      class="rounded"
      loading="eager"
      @error="handleImageError"
    />
  </GlossySwipe>
</template>

<script>
const handleImageError = (event) => {
  // For logo, show a text fallback
  event.target.style.display = 'none';
  const fallback = document.createElement('div');
  fallback.textContent = 'SENYUM';
  fallback.className = 'text-xl font-bold text-warm-800';
  event.target.parentNode.appendChild(fallback);
  console.warn('Logo failed to load');
};
</script>